import { Injectable, inject, signal } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { CoreApiService } from '../api/core.api.service';
import { State, Lga, AppConfig } from '../models/core.model';
import { ApiResponse } from '../models/api.model';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private readonly coreApi = inject(CoreApiService);

  public appConfig = signal<AppConfig | null>(null);

  fetchAppConfig(): Observable<ApiResponse<AppConfig>> {
    return this.coreApi.getAppConfig().pipe(
      tap((res) => {
        if (res.success && res.data) {
          this.appConfig.set(res.data);
        }
      })
    );
  }

  getStates(countryId: number | string = 160): Observable<ApiResponse<State[]>> {
    return this.coreApi.getStates(countryId);
  }

  getLgas(stateId: number | string): Observable<ApiResponse<Lga[]>> {
    return this.coreApi.getLgas(stateId);
  }
}
